import { Component, Vue, Ref } from "vue-property-decorator";
import LeftTree from '../components/LeftTree.vue'
import StatusRecordBody from './components/StatusRecordBody'
import { StatisticsServiceProxy, StatusRecordDTO } from '@/service-proxies/app-v2/mdc.service-proxies'
import './components/statusrecord.less'

const stsp = new StatisticsServiceProxy()
@Component({
  components: {
    LeftTree,
    StatusRecordBody
  }
})
export default class StatusRecord extends Vue {
  @Ref() statusRecordBody: StatusRecordBody
  operationData = []
  tabsdData = []
  columns = []
  loading = false
  dateTime = ''
  searchParams = {}
  init = ['Tree.vue', 'time']
  currentTab = 'gantt'

  getTableList(value, type?) {
    this.dateTime = value.date
    this.loading = true
    this.operationData = []
    let startSec = null, endSec = null
    if (value.start) {
      startSec = (new Date(value.start).getTime() - new Date(new Date().toLocaleDateString()).getTime()) / 1000
    }
    if (value.end) {
      endSec = (new Date(value.end).getTime() - new Date(new Date().toLocaleDateString()).getTime()) / 1000
    }
    let data: any = {
      date: value.date,
      workStationList: value.workStationList
    }
    if (type && type === 'table') {
      data = {
        ...data,
        duration: value.duration,
        start: startSec,
        end: endSec,
        iotStatus: value.iotStatus.length ? value.iotStatus : [1, 4]
      }
    }
    stsp.statusRecord(data).then(res =>{
      let arr = [];

      for(var i=0; i<data.workStationList.length; i++) {
        for(var j=0; j<res.items.length; j++) {
          if(data.workStationList[i].key == res.items[j].workStation.workStationId) {
            arr.unshift(res.items[j])
          }
        }
      }

      this.columns = res.collectStatusInfo
      this.operationData = arr
      this.loading = false
    })
  }

  search(value) {
    delete(value.productivityType)
    value.statisticalMethod = 'DAY'
    delete(value.shiftList)
    /*stsp.splitFilter(value).then(res =>{
      this.tabsdData = (res.items).reverse()
      this.statusRecordBody.defaultActiveKey = 0
      if(res.items){
        this.getTableList(this.tabsdData[0])
      }
    })*/
    this.dateTime = value.date
    this.searchParams = value
    if (this.currentTab === 'gantt') {
      stsp.splitFilter(value).then(res =>{
        this.tabsdData = (res.items).reverse()
        this.statusRecordBody.defaultActiveKey = 0
        if(res.items){
          this.getTableList(this.tabsdData[0], this.currentTab)
        }
      })
    } else {
      this.getTableList(value, this.currentTab)
    }
  }

  // 切换选择甘特图或数据表
  handleChange(value) {
    this.currentTab = value
    if (value === 'gantt') {
      this.init = ['Tree.vue', 'time',]
     // 默认切换到第一个日期tab
      this.getTableList(this.tabsdData[0], value)
    } else {
      this.init = ['Tree.vue', 'statusRecord', 'table']
      this.getTableList(this.searchParams, value)
    }

  }

  // 切换甘特图日期tab
  handleChangeDate(value) {
    this.tabsdData.forEach((res,index) =>{
      if (index === value){
        this.getTableList(res, this.currentTab)
      }
    })
  }

  outPut() {

  }

  leftTree() {
    return (
       <left-tree init={this.init} onSearch={value => this.search(value)} onOutPut={() => this.outPut()} queryKey="status-record"></left-tree>
    )
  }

  statusRecord() {
    return (
      this.operationData ?
      <status-record-body
        ref="statusRecordBody"
        loading={this.loading}
        tabsdData={this.tabsdData}
        data={this.operationData}
        columns={this.columns}
        dateTime={this.dateTime}
        searchParams={this.searchParams}
        onChangeTabs={value => this.handleChange(value)}
        onChangeDateTabs={value => this.handleChangeDate(value)}
      ></status-record-body> : null
    )
  }

  render() {
    return (
      <a-layout class="statusRecord-body" style="height: 100%">
        <a-layout-sider width="360" style="background: #fff; min-width:360px; overflow:auto;" class="no-fix-sider">
          {this.leftTree()}
        </a-layout-sider>
        <div v-resize={'x'}></div>
        <a-layout-content style={{ height: '100%' }}>
          {this.statusRecord()}
        </a-layout-content>
      </a-layout>
    )
  }
}
